var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-default"},[_c('my-header'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('el-backtop',{staticClass:"backtop-layout",attrs:{"target":"#__nuxt"}}),_vm._v(" "),_c('my-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }